import React, { createContext, useEffect, useState } from "react";
import { PropTypes } from "prop-types";
import { useUnmount } from "react-use";
import { useSelector } from "react-redux";

export const AbilitiesContext = createContext({});

const initialAbilities = {
  admin_users: null,
  advertising: null,
  analytics: null,
  castings: null,
  community: null,
  contents: null,
  dashboard: null,
  fast: null,
  notifications: null,
  offers: null,
  organization: null,
  platform: null,
  storefront_project: null,
};

/*
Roles:
- owner
- editor_admin
- project_admin
- content_manager_admin
- content_manager
- editorial_manager
- business_manager
- analyst_admin
- analyst
- moderator_admin
- moderator

*/
const initialRoles = [];

function AbilitiesProvider({ children }) {
  const { user } = useSelector((state) => state.fetchReducer);
  const { project, project_uuid } = useSelector(
    (state) => state.architectureReducer,
  );
  const { isLoggedIn } = useSelector((state) => state.loginReducer);

  const [abilities, setAbilities] = useState(initialAbilities);
  const [roles, setRoles] = useState(initialRoles);
  const [orgaAbility, setOrgaAbility] = useState(null);
  const [context, setContext] = useState(null);

  useEffect(() => {
    if (isLoggedIn && project_uuid) {
      setAbilities(project?.abilities);
    }
    if (isLoggedIn && !project_uuid) {
      setAbilities(initialAbilities);
    }
  }, [project_uuid, isLoggedIn]);

  useEffect(() => {
    const roles = user?.data?.roles || [];

    if (isLoggedIn && roles) {
      let orga = null;

      roles.map((role) => {
        if (["owner", "editor_admin"].includes(role)) orga = "write";
      });

      setRoles(roles);
      setOrgaAbility(orga);
    }
  }, [user]);

  useEffect(() => {
    setContext({
      abilities,
      orgaAbility,
      roles,
    });
  }, [abilities, orgaAbility, roles]);

  useUnmount(() => {
    setAbilities(initialAbilities);
  });

  return (
    <AbilitiesContext.Provider value={context}>
      {children}
    </AbilitiesContext.Provider>
  );
}

AbilitiesProvider.propTypes = {
  children: PropTypes.node,
};

export default AbilitiesProvider;
